import React from "react";
import ReactPaginate from "react-paginate";

import DisplayAttributesList from "./picklist-list";

import "./picklist.scss";

//Included React-Pagination to create pagination for Active and Archive grid
const AttributePagination = ({
    attributes,
    archiveAttribute,
    isArchiveList,
    currentPage,
    perPage,
    archiveCurrentPage,
    archivePerPage,
    handlePagination,
    handleArchivePagination,
    updatePageSize,
    updateArchivePageSize,
    viewOnlyUpdate,
}) => {
    const offset = isArchiveList ? archiveCurrentPage * archivePerPage : currentPage * perPage;
    const currentPageData = isArchiveList ? attributes.slice(offset, offset + archivePerPage) : attributes.slice(offset, offset + perPage);
    const pageCount = isArchiveList ? Math.ceil(attributes.length / archivePerPage) : Math.ceil(attributes.length / perPage);

    return (
        <>
            {
                <DisplayAttributesList
                    attributes={currentPageData}
                    archiveAttribute={archiveAttribute}
                    isArchiveList={isArchiveList}
                    viewOnlyUpdate={viewOnlyUpdate}
                />
            }

            <br />

            <div className="button-group">
                <div className="paging-section">
                    <ReactPaginate
                        previousLabel={"← Previous"}
                        nextLabel={"Next →"}
                        pageCount={pageCount}
                        forcePage={currentPage}
                        onPageChange={isArchiveList ? handleArchivePagination : handlePagination}
                        containerClassName={"pagination"}
                        previousLinkClassName={"pagination__link"}
                        nextLinkClassName={"pagination__link"}
                        disabledClassName={"pagination__link--disabled"}
                        activeClassName={"pagination__link--active"}
                    />
                </div>

                {/*custom Number of rows dropdown is added */}
                <span className="paging-rows select-wrap -pageSizeOptions">
                    <select onChange={isArchiveList ? updateArchivePageSize : updatePageSize} aria-label="rows per page">
                        <option value="5">5 rows</option>
                        <option value="10">10 rows</option>
                        <option value="20">20 rows</option>
                        <option value="25">25 rows</option>
                        <option value="50">50 rows</option>
                        <option value="100">100 rows</option>
                    </select>
                </span>

                <label className="picklist-totalCount">Total Records : {attributes.length}</label>
            </div>
        </>
    );
};

export default AttributePagination;
